import { AvailableTimeMinutes, DeliveryTypeProduct } from '@entities/Delivery';
import {
  sortByQuantityNoToday,
  sortByQuantityToday,
  sortByStatusDeliveryNoToday,
  sortByStatusDeliveryToday,
  sortPartner,
} from '@entities/Shop/helpers/sort/sortByFieldSort';
import { fetchAvailabilityProduct } from '@entities/Shop/module/services/getAvailabilityProduct';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';
import { sortByDistance } from '../../helpers/sort';
import { AvailabilityProductSchema, ShopType, StatusOrderFromStock } from '../types/availabilityProductSchema';

const initialState: AvailabilityProductSchema = {
  pickUpToday: [],
  pickUpLater: [],
  pickUpAllShops: [],
  overall: null,
  delivery: null,
  orderFromStock: null,
  isLoaded: false,
  isLoadedDistance: false,
};

export const availabilityProductSlice = createSlice({
  name: 'availabilityProductSlice',
  initialState,
  reducers: {
    filterShopsPickUpToday: (state, action: PayloadAction<boolean>) => {
      if (state.isLoaded && action.payload) {
        state.pickUpToday = state.pickUpToday
          .filter(shop => shop.sticky === true || shop.statusDeliveryToday !== AvailableTimeMinutes.CONST_TWO_HOURS)
          .sort(sortByQuantityToday)
          .sort(sortByDistance)
          .sort(sortByStatusDeliveryToday)
          .sort(sortPartner);
      } else if (state.isLoaded && !action.payload) {
        state.pickUpToday = state.pickUpAllShops
          ?.filter(shop => shop.type.includes(DeliveryTypeProduct.Today))
          .sort(sortByQuantityToday)
          .sort(sortByDistance)
          .sort(sortByStatusDeliveryToday)
          .sort(sortPartner);
      }
    },
    addDistance: (state, action: PayloadAction<ShopType[]>) => {
      if (!state.isLoadedDistance) {
        state.pickUpAllShops = action.payload;
        state.pickUpToday = action.payload
          ?.filter(shop => shop.type.includes(DeliveryTypeProduct.Today))
          .sort(sortByQuantityToday)
          .sort(sortByDistance)
          .sort(sortByStatusDeliveryToday)
          .sort(sortPartner);
        state.pickUpLater = action.payload
          .filter(shop => shop.type.includes(DeliveryTypeProduct.NotToday))
          .sort(sortByQuantityToday)
          .sort(sortByDistance)
          .sort(sortByStatusDeliveryToday)
          .sort(sortPartner);
        state.isLoadedDistance = true;
      }
    },
  },
  extraReducers: builder => {
    builder.addCase(HYDRATE, (state, action: any) => {
      return {
        ...state,
        ...action.payload.availabilityProductSlice,
      };
    });
    builder.addCase(fetchAvailabilityProduct.fulfilled, (state, action) => {
      if (action.payload) {
        state.delivery = action.payload.delivery;
        if (action.payload.orderFromStock) {
          state.orderFromStock = {
            ...action.payload.orderFromStock,
            status: StatusOrderFromStock.Free,
          };
        }
        state.pickUpAllShops = action.payload.pickUpAllShops;
        state.pickUpToday = action.payload.pickUpAllShops
          ?.filter(shop => shop.type.includes(DeliveryTypeProduct.Today))
          .sort(sortByQuantityToday)
          .sort(sortByDistance)
          .sort(sortByStatusDeliveryToday)
          .sort(sortPartner);
        state.pickUpLater = action.payload.pickUpAllShops
          ?.filter(shop => shop.type.includes(DeliveryTypeProduct.NotToday))
          // .sort(sortByFieldSort)
          .sort(sortByQuantityNoToday)
          .sort(sortByDistance)
          .sort(sortByStatusDeliveryNoToday)
          .sort(sortPartner);
        state.overall = action.payload.overall;
      }
      state.isLoaded = true;
    });
  },
});

export const { actions: availabilityProductActions } = availabilityProductSlice;
